import React from "react";
import { days } from "./utils.js";

const ScheduleHeader = ({
  viewMode,
  setViewMode,
  handleResetSchedule,
  setShowSaveModal,
  onNavigate,
  studentsNotSet,
  selectedDay,
  setSelectedDay,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  allowResetSchedule = true, // Default to true if not provided
}) => {
  return (
    <>
      <div className="schedule-header">
        <h1>📅 Trainingsplan</h1>
      </div>

      <div className="schedule-controls-sticky">
        <div className="schedule-controls">
          <div className="button-group">
            <button
              onClick={onUndo}
              disabled={!canUndo}
              title="Rückgängig (Ctrl+Z)"
            >
              ↶ Rückgängig
            </button>

            <button
              onClick={onRedo}
              disabled={!canRedo}
              title="Wiederherstellen (Ctrl+Y)"
            >
              ↷ Wiederherstellen
            </button>

            <button
              onClick={() => setViewMode(viewMode === "day" ? "week" : "day")}
            >
              {viewMode === "day" ? "📊 Wochenansicht" : "📋 Tagesansicht"}
            </button>

            <button
              onClick={handleResetSchedule}
              disabled={!allowResetSchedule}
              title={!allowResetSchedule ? "Plan-Generieren wurde in den Einstellungen deaktiviert" : ""}
            >
              ⚡ Plan generieren
            </button>

            <button onClick={() => setShowSaveModal(true)}>
              💾 Speichern
            </button>

            <button
              onClick={() => {
                if (onNavigate) {
                  onNavigate("notAssigned");
                }
              }}
            >
              👥 Nicht zugewiesen ({studentsNotSet.length})
            </button>
          </div>

          <div className="day-selector">
            {days.map((d) => (
              <button
                key={d}
                className={d === selectedDay ? "active" : ""}
                onClick={() => setSelectedDay(d)}
                aria-pressed={d === selectedDay}
              >
                {d}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleHeader;
